export enum GoalStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
}

export enum GoalStatusLabel {
  NEW = "New",
  IN_PROGRESS = "In Progress",
  COMPLETED = "Completed",
}
